import {
  useAllItemTypesQuery,
  AllItemTypesQuery,
} from '@/graphql/queries/allItemTypes.generated';
import { DEFAULT_PAGE_SIZE } from './utils';
import { ItemTypeCategory } from '@/graphql/generatedTypes';

export type ItemType = AllItemTypesQuery['itemTypes']['items'][number];

interface UseAllAssetTypesOptions {
  storeId?: string;
  page: number;
  pageSize?: number;
  skip?: boolean;
  showArchived?: boolean;
}

export function useAllAssetTypes({
  storeId,
  page = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  skip = false,
  showArchived = false,
}: UseAllAssetTypesOptions) {
  const { data, loading, error, refetch } = useAllItemTypesQuery({
    variables: {
      filter: { category: ItemTypeCategory.StoreAsset, archived: showArchived },
      skip: (page - 1) * pageSize,
      take: pageSize,
      price_for_store_id: storeId,
    },
    skip: skip || !storeId,
    fetchPolicy: 'no-cache',
  });

  const items = data?.itemTypes?.items ?? [];
  const total = data?.itemTypes?.total ?? 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return {
    items,
    total,
    totalPages,
    loading,
    error,
    refetch,
  };
}
